export default "__VITE_ASSET__CQur1Knx__"